import solicitudFuncionesServices from '@/services/solicitudFunciones.services'
import solicitudFuncionesRemoverServices from '@/services/solicitudFuncionesRemover.services'

const normalizarCatalogoTiposCompensacion = (items = []) =>
	items
		.map((item) => ({
			id: item?.id ?? item?.id_tipo_compensacion ?? null,
			nombre: item?.nombre ?? item?.tipo_compensacion ?? item?.name ?? '',
		}))
		.filter((item) => item.id !== null && item.nombre)

const obtenerItemsRespuesta = (response) => {
	const data = response?.data
	if (Array.isArray(data?.data)) return data.data
	if (Array.isArray(data)) return data
	return []
}

export default {
	namespaced: true,
	state: {
		idEmpleadoPuesto: null,
		idSolicitudCargada: null,
		fechaRetiro: '',
		motivoRetiro: '',
		tiposCompensacion: [],
		funcionesAsignadas: [],
		totalFuncionesAjustadas: null,
		totalFuncionesRemovidas: null,
		montoTotalFuncionesAjustadas: null,
		montoTotalFuncionesRemovidas: null,
	},
	mutations: {
		setIdEmpleadoPuesto(state, idEmpleadoPuesto) {
			state.idEmpleadoPuesto = idEmpleadoPuesto ?? null
		},
		setIdSolicitudCargada(state, idSolicitud) {
			state.idSolicitudCargada = idSolicitud ?? null
		},
		setFechaRetiro(state, fechaRetiro) {
			state.fechaRetiro = fechaRetiro || ''
		},
		setMotivoRetiro(state, motivoRetiro) {
			state.motivoRetiro = motivoRetiro || ''
		},
		setTiposCompensacion(state, tiposCompensacion) {
			state.tiposCompensacion = Array.isArray(tiposCompensacion) ? tiposCompensacion : []
		},
		setFuncionesAsignadas(state, funcionesAsignadas) {
			state.funcionesAsignadas = Array.isArray(funcionesAsignadas) ? funcionesAsignadas : []
		},
		setTotalesFunciones(state, { totalFuncionesAjustadas = null, totalFuncionesRemovidas = null } = {}) {
			state.totalFuncionesAjustadas = Number.isFinite(Number(totalFuncionesAjustadas))
				? Number(totalFuncionesAjustadas)
				: null
			state.totalFuncionesRemovidas = Number.isFinite(Number(totalFuncionesRemovidas))
				? Number(totalFuncionesRemovidas)
				: null
		},
		setMontosTotalesFunciones(state, { montoTotalFuncionesAjustadas = null, montoTotalFuncionesRemovidas = null } = {}) {
			state.montoTotalFuncionesAjustadas = Number.isFinite(Number(montoTotalFuncionesAjustadas))
				? Number(montoTotalFuncionesAjustadas)
				: null
			state.montoTotalFuncionesRemovidas = Number.isFinite(Number(montoTotalFuncionesRemovidas))
				? Number(montoTotalFuncionesRemovidas)
				: null
		},
		actualizarEstadoTabFuncion(state, { id, estadoTab }) {
			const funcion = state.funcionesAsignadas.find((f) => f.id_funcion_asignada === id || f.id === id)
			if (funcion) {
				funcion.estadoTab = estadoTab
			}
		},
		removerActividad(state, { idFuncion, idActividad }) {
			const funcion = state.funcionesAsignadas.find(f => f.id === idFuncion)
			if (!funcion) return
			// Detectar modo: array unificado con flag removido
			const usaFlagRemovido = funcion.actividades.some((a) => typeof a.removido === 'boolean')
			if (usaFlagRemovido) {
				const actividad = funcion.actividades.find(a => a.id_actividad === idActividad || a.id === idActividad)
				if (actividad) {
					actividad.removido = true
					funcion.actividades_asignadas = funcion.actividades.filter(a => !a.removido).length
					funcion.actividades_ajustadas = funcion.actividades.filter(a => a.removido).length
				}
			} else {
				// Modo CREAR: mover entre arrays
				const index = funcion.actividades.findIndex(a => a.id_actividad === idActividad || a.id === idActividad)
				if (index !== -1) {
					const [actividad] = funcion.actividades.splice(index, 1)
					funcion.actividades_removidas = funcion.actividades_removidas || []
					funcion.actividades_removidas.push(actividad)
					funcion.actividades_asignadas = funcion.actividades.length
					funcion.actividades_ajustadas = funcion.actividades_removidas.length
				}
			}
		},
		restablecerActividad(state, { idFuncion, idActividad }) {
			const funcion = state.funcionesAsignadas.find(f => f.id === idFuncion)
			if (!funcion) return
			const usaFlagRemovido = funcion.actividades.some((a) => typeof a.removido === 'boolean')
			if (usaFlagRemovido) {
				const actividad = funcion.actividades.find(a => a.id_actividad === idActividad || a.id === idActividad)
				if (actividad) {
					actividad.removido = false
					funcion.actividades_asignadas = funcion.actividades.filter(a => !a.removido).length
					funcion.actividades_ajustadas = funcion.actividades.filter(a => a.removido).length
				}
			} else {
				// Modo CREAR: mover entre arrays
				if (funcion.actividades_removidas) {
					const index = funcion.actividades_removidas.findIndex(a => a.id_actividad === idActividad || a.id === idActividad)
					if (index !== -1) {
						const [actividad] = funcion.actividades_removidas.splice(index, 1)
						funcion.actividades.push(actividad)
						funcion.actividades_asignadas = funcion.actividades.length
						funcion.actividades_ajustadas = funcion.actividades_removidas.length
					}
				}
			}
		},
		restablecerTodasActividades(state, idFuncion) {
			const funcion = state.funcionesAsignadas.find(f => f.id === idFuncion)
			if (funcion && funcion.actividades_removidas?.length > 0) {
				funcion.actividades.push(...funcion.actividades_removidas)
				funcion.actividades_removidas = []
				funcion.actividades_asignadas = funcion.actividades.length
				funcion.actividades_ajustadas = funcion.actividades_removidas.length
			}
		},
		resetSolicitudRemoverFunciones(state) {
			state.idEmpleadoPuesto = null
			state.idSolicitudCargada = null
			state.fechaRetiro = ''
			state.motivoRetiro = ''
			state.tiposCompensacion = []
			state.funcionesAsignadas = []
			state.totalFuncionesAjustadas = null
			state.totalFuncionesRemovidas = null
			state.montoTotalFuncionesAjustadas = null
			state.montoTotalFuncionesRemovidas = null
		},
	},
	actions: {
		setIdEmpleadoPuesto({ commit }, idEmpleadoPuesto) {
			commit('setIdEmpleadoPuesto', idEmpleadoPuesto)
		},
		setFechaRetiro({ commit }, fechaRetiro) {
			commit('setFechaRetiro', fechaRetiro)
		},
		setMotivoRetiro({ commit }, motivoRetiro) {
			commit('setMotivoRetiro', motivoRetiro)
		},
		setTiposCompensacion({ commit }, tiposCompensacion) {
			commit('setTiposCompensacion', tiposCompensacion)
		},
		async cargarTiposCompensacion({ commit }) {
			try {
				const response = await solicitudFuncionesServices.getCatalogoTiposCompensacion()
				const items = obtenerItemsRespuesta(response)
				commit('setTiposCompensacion', normalizarCatalogoTiposCompensacion(items))
			} catch (error) {
				commit('setTiposCompensacion', [])
				console.error('Error al cargar tipos de compensacion:', error)
			}
		},
		setFuncionesAsignadas({ commit }, funcionesAsignadas) {
			commit('setFuncionesAsignadas', funcionesAsignadas)
		},
		setTotalesFunciones({ commit }, payload) {
			commit('setTotalesFunciones', payload)
		},
		setMontosTotalesFunciones({ commit }, payload) {
			commit('setMontosTotalesFunciones', payload)
		},
		actualizarEstadoTabFuncion({ commit }, payload) {
			commit('actualizarEstadoTabFuncion', payload)
		},
		removerActividad({ commit }, payload) {
			commit('removerActividad', payload)
		},
		restablecerActividad({ commit }, payload) {
			commit('restablecerActividad', payload)
		},
		restablecerTodasActividades({ commit }, idFuncion) {
			commit('restablecerTodasActividades', idFuncion)
		},
		async cargarFuncionesAsignadas({ commit }, idEmpleadoPuesto) {
			if (!idEmpleadoPuesto) {
				commit('setFuncionesAsignadas', [])
				return
			}
			try {
				const response = await solicitudFuncionesRemoverServices.getFuncionesAsignadasRemover(idEmpleadoPuesto)
				const items = obtenerItemsRespuesta(response)
				// Inicializamos estadoTab a 0 (Ajustadas) para todas las funciones y agregamos id como fallback
				const normalizadas = items.map(item => ({
					...item,
					id: item.id_funcion_asignada ?? item.id_funcion,
					estadoTab: 0,
					actividades: Array.isArray(item.actividades) ? item.actividades : [],
					actividades_removidas: [],
				}))
				commit('setFuncionesAsignadas', normalizadas)
			} catch (error) {
				commit('setFuncionesAsignadas', [])
				console.error('Error al cargar funciones asignadas para remover:', error)
			}
		},
		resetSolicitudRemoverFunciones({ commit }) {
			commit('resetSolicitudRemoverFunciones')
		},
	},
}
